export default __webpack_public_path__ + "static/money-6a624e35b35079ea59207dac7873887b5d7a7a70b4f4ab5a6015f0d1f7f5f519.svg";